import React from 'react';
import { Typography } from '../../index';

export interface ISlideProps {
	step: number;
	image: string;
	title: string;
	description: string;
}

export const Slide = ({ step, image, title, description }: ISlideProps) => {
	return (
		<div className="flex flex-col items-center shrink-0 w-full">
			<div className="mb-4">
				<img src={image} alt={title} />
			</div>
			<div className="px-5">
				<div className="flex items-center justify-center gap-2 mb-2">
					<Typography
						className="flex justify-center items-center border-solid border border-gray-100 rounded-half w-4 h-4"
						size="lgEven">
						{step}
					</Typography>
					<Typography component="h3" variant="title" size="xlEven">
						{title}
					</Typography>
				</div>
				<Typography className="text-center" component="p" size="lgEven">
					{description}
				</Typography>
			</div>
		</div>
	);
};
